"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseBigintDef = void 0;
function parseBigintDef() {
    return {
        type: "integer",
        format: "int64",
    };
}
exports.parseBigintDef = parseBigintDef;
